import React, { MouseEvent, useState } from "react"

import { Grid, IconButton, Popover, Typography } from "@material-ui/core"
import {
	InfoOutlined as InfoIcon
} from "@material-ui/icons"
import useStyles from "@/pages/Admin/Templates/ManageTemplateForm/ManageTemplateButtonsForm/ManageTemplateButtonsFormURLTipsPopover/styles"

const EXAMPLES_VALID_URLs = {
	dynamic: [
		"https://www.exemplo.com/{{variable1}}",
		"https://exemplo.com/produto/{{variable1}}",
		"https://www.exemplo.com/produto/{{variable1}}/detalhes",
		"https://exemplo.com/produto/{{variable1}}/detalhes"
	],
	static: [
		"https://www.exemplo.com",
		"https://exemplo.com/produto",
		"https://www.exemplo.com/produto/detalhes",
		"https://exemplo.com/produto/detalhes"
	]
}

const EXAMPLES_INVALID_URLs = {
	dynamic: [
		"http://www.exemplo.com/{{variable1}}",
		"https://{{variable1}}/exemplo.com/produto/detalhes",
		"https://www.exemplo.com/produto/productId/detalhes",
		"www.exemplo.com/produto/{productId}/detalhes"
	],
	static: [
		"http://www.exemplo.com",
		"https//exemplo.com/produto/detalhes",
		"www.exemplo.com/produto/detalhes",
		"exemplo.com/produto/detalhes"
	]
}

type ManageTemplateButtonsFormURLTipsPopoverProps = {
	urlType: "static" | "dynamic"
}

const ManageTemplateButtonsFormURLTipsPopover: React.FC<ManageTemplateButtonsFormURLTipsPopoverProps> = (props) => {
	const { urlType } = props
	const [popoverAnchorElement, setPopoverAnchorElement] = useState<HTMLElement | null>(null)
	const [isPopoverOpen, setIsPopoverOpen] = useState(false)

	const classes = useStyles()

	const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
		setPopoverAnchorElement(event.currentTarget)
		setIsPopoverOpen(true)
	}

	const handlePopoverClose = () => {
		setPopoverAnchorElement(null)
		setIsPopoverOpen(false)
	}

	return (
		<>
			<IconButton
				className={classes.iconButton}
				aria-owns={isPopoverOpen ? "mouse-over-popover" : undefined}
				aria-haspopup="true"
				onClick={handlePopoverOpen}
			>
				<InfoIcon className={classes.iconButtonSize} />
			</IconButton>
			<Popover
				id="mouse-over-popover"
				open={isPopoverOpen}
				onClose={handlePopoverClose}
				anchorEl={popoverAnchorElement}
				classes={{
					paper: classes.popover
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}>
				<Grid container direction="column" spacing={3}>
					<Grid item>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Typography variant="h5" className={classes.popoverTitle}>
									Algumas regrinhas importantes para a URL {urlType === "static" ? "estática" : "dinâmica"} 👇
								</Typography>
							</Grid>
							<Grid item>
								<Typography variant="body2">
									Preparamos alguns exemplos de URLs válidas e inválidas para te ajudar a criar suas URLs corretamente.
								</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Grid container direction="column">
							<Grid item>
								<Typography variant="h5">
									✅ URL válidas:
								</Typography>
							</Grid>
							<Grid item>
								{EXAMPLES_VALID_URLs[urlType].map((example, index) => (
									<Typography key={index} variant="body2" className={classes.exampleMessage}>
										{example}
									</Typography>
								))}
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Grid container direction="column">
							<Grid item>
								<Typography variant="h5">
									❌ URL inválidas:
								</Typography>
							</Grid>
							<Grid item>
								{EXAMPLES_INVALID_URLs[urlType].map((example, index) => (
									<Typography key={index} variant="body2" className={classes.exampleMessage}>
										{example}
									</Typography>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Popover>
		</>
	)
}

export default ManageTemplateButtonsFormURLTipsPopover
